import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonServiceService } from '../services/common-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-gdpr',
  templateUrl: './gdpr.component.html',
  styleUrls: ['./gdpr.component.scss']
})
export class GDPRComponent implements OnInit {

  readonly privacyUrl = 'https://www.idhsustainabletrade.com/privacy-statement/';
  readonly defaultTitle =
    'Who will be able to see the personal information that I will enter on this website?';

  privacyTitle = this.defaultTitle;
  privacyCopy = '';
  useCmsPrivacy = false;
  privacyLoading = !!environment.privacyStatementSectionId;

  gdprPoints: any = [
    {
      policyPoint: 'IDH will be the only organization with access to your data and we will keep this information under strict confidentiality.',
    },
    {
      policyPoint: 'IDH is an international organization that seeks to improve and scale up sustainable production & trade to deliver large-scale impact on the Sustainable Development Goals.',
    },
    {
      policyPoint: 'The personal information entered on this website will allow communication between IDH and users of the PRISM Portal.',
    },
    {
      policyPoint: 'IDH will store your answers and location details for a maximum of 10 years in order to be able to follow up at a later stage.',
    },
  ];

  gdprChecked = false;

  constructor(
    public dialogRef: MatDialogRef<GDPRComponent>,
    private snackBar: MatSnackBar,
    private commonService: CommonServiceService
  ) {
    this.gdprChecked = JSON.parse(sessionStorage.getItem('gdprConfirmation') || 'false');
  }

  ngOnInit(): void {
    this.loadPrivacyStatement();
  }

  loadPrivacyStatement(): void {
    const sectionId = environment.privacyStatementSectionId;
    if (!sectionId) {
      return;
    }
    this.privacyLoading = true;
    this.commonService.getPageDetails(sectionId).subscribe({
      next: (res) => {
        const row = res?.data?.[0];
        const copy = row?.subTitle?.trim();
        if (res?.success && copy) {
          this.privacyCopy = copy;
          this.useCmsPrivacy = true;
        }
      },
      error: () => {
        this.privacyLoading = false;
      },
      complete: () => {
        this.privacyLoading = false;
      },
    });
  }

  get showPrivacyLink(): boolean {
    if (!this.useCmsPrivacy) {
      return true;
    }
    return !this.privacyCopy.includes('idhsustainabletrade.com/privacy-statement');
  }

  isDisable(): boolean {
    return !this.gdprChecked;
  }

  selectGDPR(event: any): void {
    this.gdprChecked = event?.checked;
  }

  submitGDPR(): void {
    this.closeDialog(true);
  }

  closeDialog(response: any): void {
    if (response) {
      this.dialogRef.close(true);
    }
  }

  openSnackBar(message: any, action = '', className = 'parmary'): void {
    this.snackBar.open(message, action, {
      duration: 3000,
      panelClass: [className]
    });
  }
}
